var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrosoft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8H23.2381V23.2381H8V8Z",
    fill: "#F35325"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7619 8H40V23.2381H24.7619V8Z",
    fill: "#81BC06"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 24.7619H23.2381V40H8V24.7619Z",
    fill: "#05A6F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7619 24.7619H40V40H24.7619V24.7619Z",
    fill: "#FFBA08"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoft);
export default __webpack_public_path__ + "static/media/Microsoft.1c6c7ae8dbcbac6159b7f4bae931b936.svg";
export { ForwardRef as ReactComponent };